var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"card-image",class:_vm.classes},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":_vm.imageAlt}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }